import { render, staticRenderFns } from "./ReverseSale.vue?vue&type=template&id=70c96bb9&scoped=true&"
import script from "./ReverseSale.vue?vue&type=script&lang=js&"
export * from "./ReverseSale.vue?vue&type=script&lang=js&"
import style0 from "./ReverseSale.vue?vue&type=style&index=0&id=70c96bb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c96bb9",
  null
  
)

export default component.exports